import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateStudentForm from "../../forms/CreateOrUpdateStudentForm";

interface CreateStudentModalProps {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  error: string | null;
}

const CreateStudentModal: React.FC<CreateStudentModalProps> = ({
  open,
  onClose,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Register New Student"
    width="md"
    loading={loading}
  >
    <CreateOrUpdateStudentForm loading={loading} error={error} />
  </AppModal>
);

export default CreateStudentModal;
